export const OUTPUT_FACTORY_IDS = {
  EMPLAS_1: 'emplas-1',
  EMPLAS_2: 'emplas-2'
};

const DISPLAY_TYPE_MAP = {
  0: 'bench',
  1: 'autoline',
  2: 'sch',
  3: 'stuga',
  bench: 'bench',
  autoline: 'autoline',
  sch: 'sch',
  stuga: 'stuga'
};

const METRIC_TYPE_MAP = {
  0: 'items',
  1: 'piecesCut',
  2: 'sashes',
  3: 'frameBoxes',
  4: 'weldedCill',
  5: 'compositeDoorGearing',
  6: 'weldedCillWelding',
  items: 'items',
  piecescut: 'piecesCut',
  sashes: 'sashes',
  frameboxes: 'frameBoxes',
  weldedcill: 'weldedCill',
  compositedoorgearing: 'compositeDoorGearing',
  weldedcillwelding: 'weldedCillWelding'
};

export const slugifyStationPath = value =>
  String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

const normalizeDisplayType = value => {
  const key = typeof value === 'string' ? value.trim().toLowerCase() : value;
  return DISPLAY_TYPE_MAP[key] || 'bench';
};

const normalizeMetricType = value => {
  const key = typeof value === 'string' ? value.trim().toLowerCase() : value;
  return METRIC_TYPE_MAP[key] || 'items';
};

const normalizeDataSources = value => {
  if (!Array.isArray(value) || !value.length) {
    return ['production'];
  }

  return value.map(item => String(item || '').trim().toLowerCase()).filter(Boolean);
};

const getMetadataFactories = payload =>
  payload?.factories ||
  payload?.Factories ||
  payload?.data?.factories ||
  payload?.data?.Factories ||
  [];

export const buildFactoryOptions = factories =>
  factories.map(factory => ({
    value: factory.id,
    label: factory.name
  }));

export const buildStationPathsByFactory = factories =>
  factories.reduce((acc, factory) => {
    acc[factory.id] = factory.areas
      .flatMap(areaConfig => areaConfig.groups)
      .flatMap(groupConfig => groupConfig.stations)
      .map(stationConfig => stationConfig.stationPath)
      .filter(Boolean);
    return acc;
  }, {});

const buildStationFromMetadata = (stationMeta, groupConfig) => {
  const stationName = stationMeta?.stationName || stationMeta?.StationName || '';
  const stationPath =
    stationMeta?.stationPath ||
    stationMeta?.StationPath ||
    stationMeta?.stationPathHint ||
    stationMeta?.StationPathHint ||
    stationName;

  return {
    name: stationName,
    stationPath: slugifyStationPath(stationPath),
    displayType: normalizeDisplayType(
      groupConfig?.displayType ?? groupConfig?.DisplayType
    ),
    metricType: normalizeMetricType(
      groupConfig?.metricType ?? groupConfig?.MetricType
    ),
    dataSources: normalizeDataSources(
      stationMeta?.dataSources ??
        stationMeta?.DataSources ??
        groupConfig?.dataSources ??
        groupConfig?.DataSources
    ),
    isResolved: Boolean(stationMeta?.isResolved ?? stationMeta?.IsResolved),
    resolutionNote:
      stationMeta?.resolutionNote || stationMeta?.ResolutionNote || null
  };
};

export const buildOutputPerformanceFactoriesFromMetadata = payload => {
  const factories = getMetadataFactories(payload);

  if (!Array.isArray(factories) || !factories.length) {
    return [];
  }

  return factories
    .map(factory => ({
      id: factory?.id || factory?.Id,
      name: factory?.name || factory?.Name,
      areas: (factory?.areas || factory?.Areas || []).map(areaConfig => ({
        name: areaConfig?.name || areaConfig?.Name,
        groups: (areaConfig?.groups || areaConfig?.Groups || []).map(groupConfig => ({
          name: groupConfig?.name || groupConfig?.Name,
          displayType: normalizeDisplayType(
            groupConfig?.displayType ?? groupConfig?.DisplayType
          ),
          metricType: normalizeMetricType(
            groupConfig?.metricType ?? groupConfig?.MetricType
          ),
          stations: (groupConfig?.stations || groupConfig?.Stations || []).map(
            stationMeta => buildStationFromMetadata(stationMeta, groupConfig)
          )
        }))
      }))
    }))
    .filter(factory => factory.id && factory.name);
};
